<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th>Name</th>
        <th>
          <button
            (click)="price()"
            style="margin-left: 5px"
            class="add"
            mat-raised-button
            color="basic"
          >
            Add price
          </button>
        </th>
        <th>
          <span style="display: flex; flex-direction: row">
            <button
              class="add"
              mat-raised-button
              color="basic"
              (click)="addNew()"
            >
              Add New
            </button>
            <button
              (click)="copy()"
              style="margin-left: 5px"
              class="add"
              mat-raised-button
              color="basic"
            >
              Copy
            </button>
          </span>
        </th>
      </tr>
      <tr class="td" *ngFor="let soc of socs" style="cursor: pointer">
        <td (click)="viewAll(soc)">{{ soc.SOC_NAME }}</td>
        <td (click)="viewAll(soc)">{{ soc.SOC_Short_COde }}</td>
        <td>
          <button mat-raised-button color="primary" (click)="edit(soc)">
            Edit
          </button>
          <button
            mat-raised-button
            color="primary"
            style="margin-left: 5px"
            (click)="delete(soc)"
          >
            Delete
          </button>
          <button
            style="margin-left: 5px"
            mat-raised-button
            color="primary"
            (click)="downloadAllSoc(soc)"
          >
            Download
          </button>
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
        <p>{{ Errors }}</p>
      </div>
    </div>
    <div class="last"></div>
  </div>

  <div *ngSwitchCase="'view'">
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th>
          <button
            mat-raised-button
            color="primary"
            style="margin-right: 20px"
            (click)="back()"
          >
            Back</button
          >Name
        </th>
        <th>price</th>
      </tr>
      <tr class="td" *ngFor="let soc of socItems">
        <td>{{ soc.name }}</td>
        <td>{{ soc.service_price | currency : "₦" }}</td>
      </tr>
    </table>
  </div>

  <form
    [formGroup]="stateForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'add'"
  >
    <div class="post">
      <div class="title">Create SOC</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="SOC_NAME" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Company</mat-label>
            <mat-select formControlName="company_id" matNativeControl required>
              <mat-option
                *ngFor="let company of companies"
                [value]="company.Company_code"
                >{{ company.Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Short Code</mat-label>
            <input formControlName="SOC_Short_COde" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Remarks</mat-label>
            <input formControlName="SOC_REMARKs" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Branch</mat-label>
            <mat-select formControlName="branch_code" matNativeControl required>
              <mat-option
                *ngFor="let branch of branchs"
                [value]="branch.Branch_Code"
                >{{ branch.Branch_Name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="Status" matNativeControl required>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="" style="margin-bottom: 30px">
        <button
          class="create"
          type="submit"
          mat-raised-button
          color="primary"
          style="margin-left: 20px"
        >
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
  <form
    [formGroup]="copyForm"
    (ngSubmit)="onAddPrice($event)"
    class="post"
    *ngSwitchCase="'price'"
  >
    <div class="post">
      <div class="title">Add Price</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>SOC</mat-label>
            <mat-select formControlName="select_soc" matNativeControl>
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <!-- <span class="input">
          <mat-form-field>
            <mat-label>Rate Type</mat-label>
            <mat-select formControlName="rate_type" matNativeControl>
              <mat-option value="1">Increment</mat-option>
              <mat-option value="-1">Decrement</mat-option>
            </mat-select>
          </mat-form-field>
        </span> -->
        <!-- <span class="input">
          <mat-form-field>
            <mat-label>Rate (%)</mat-label>
            <input
              type="number"
              formControlName="rate_percent"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </span> -->
      </div>
      <div class="form" style="display: flex; flex-direction: row">
        <span style="width: 250px">
          <mat-form-field>
            <mat-label>Service</mat-label>
            <input
              [(ngModel)]="itemName"
              (ngModelChange)="refchg1($event)"
              matInput
              [ngModelOptions]="{ standalone: true }"
            />
            <div class="float" style="position: relative; width: 3px">
              <div class="ret" *ngIf="visible">
                <!-- <div class="list" *ngIf="refLoad" >Loading</div> -->
                <div
                  class="list"
                  (click)="setItem1(item)"
                  *ngFor="let item of serchItems"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </mat-form-field>
        </span>
        <span style="width: 100px; margin-left: 10px">
          <mat-form-field style="width: 100px; margin-left: 10px">
            <mat-label>Amount</mat-label>
            <input
              type="number"
              formControlName="amount"
              matInput
              placeholder="20000"
            />
          </mat-form-field>
        </span>
        <div style="display: flex; align-items: center; gap: 10px">
          <span>
            <button
              class="create"
              type="button"
              mat-raised-button
              color="primary"
              style="margin-left: 50px; margin-top: 20px"
              (click)="addSocPrice()"
            >
              Add
            </button>
          </span>
          <span>
            <button
              class="create"
              type="button"
              mat-raised-button
              color="primary"
              style="margin-top: 20px"
              (click)="downloadCsv()"
            >
              CSV Template
            </button>
          </span>
        </div>
      </div>
      <div>
        <input type="file" #fileInput (change)="onFileChange($event)" />
      </div>
      <div class="table">
        <div
          class="service"
          (click)="deleteItem2(service.name)"
          *ngFor="let service of itemsAll"
        >
          {{ service.name }}<br />
          {{ service.amount | currency : "N" }}<br />
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
  <form
    [formGroup]="copyForm"
    (ngSubmit)="onCopy($event)"
    class="post"
    *ngSwitchCase="'copy'"
  >
    <div class="post">
      <div class="title">Copy SOC</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>SOC</mat-label>
            <mat-select formControlName="select_soc" matNativeControl>
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Base Base</mat-label>
            <mat-select formControlName="base_soc" matNativeControl>
              <mat-option *ngFor="let soc of socs" [value]="soc.SOC_ID">{{
                soc.SOC_NAME
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Rate Type</mat-label>
            <mat-select formControlName="rate_type" matNativeControl>
              <mat-option value="1">Increment</mat-option>
              <mat-option value="-1">Decrement</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Rate (%)</mat-label>
            <input
              type="number"
              formControlName="rate_percent"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </span>
      </div>
      <div class="form">
        <span style="width: 100px">
          <mat-form-field style="width: 200px">
            <mat-label>Service</mat-label>
            <input
              [(ngModel)]="itemName"
              (ngModelChange)="refchg($event)"
              matInput
              [ngModelOptions]="{ standalone: true }"
            />
            <div class="float" style="position: relative; width: 3px">
              <div class="ret" *ngIf="visible">
                <!-- <div class="list" *ngIf="refLoad" >Loading</div> -->
                <div
                  class="list"
                  (click)="setItem(item)"
                  *ngFor="let item of serchItems"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </mat-form-field>
        </span>
        <span>
          <button
            class="create"
            type="button"
            mat-raised-button
            color="primary"
            style="margin-left: 50px"
            (click)="add()"
          >
            Add
          </button>
        </span>
        <div class="table">
          <div
            class="service"
            (click)="deleteItem(service.service_id)"
            *ngFor="let service of lstServices"
          >
            {{ service.service_name }}<br />
          </div>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
  <form
    [formGroup]="stateForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'edit'"
  >
    <div class="post">
      <div class="title">Edit SOC</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="SOC_NAME" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Short Code</mat-label>
            <input formControlName="SOC_Short_COde" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Remarks</mat-label>
            <input formControlName="SOC_REMARKs" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="Status" matNativeControl required>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <span style="width: 150px">
          <mat-form-field style="width: 200px">
            <mat-label>Service</mat-label>
            <input
              [(ngModel)]="itemName"
              (ngModelChange)="refchg($event)"
              matInput
              [ngModelOptions]="{ standalone: true }"
            />
            <div class="float" style="position: relative; width: 3px">
              <div class="ret" *ngIf="visible">
                <!-- <div class="list" *ngIf="refLoad" >Loading</div> -->
                <div
                  class="list"
                  (click)="setItem(item)"
                  *ngFor="let item of serchItems"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </mat-form-field>
        </span>
        <span style="width: 200px">
          <mat-form-field style="width: 200px; margin-left: 20px">
            <mat-label>Amount</mat-label>
            <input
              [(ngModel)]="discount"
              (change)="onChange($event)"
              matInput
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </span>
        <span>
          <button
            class="create"
            type="button"
            mat-raised-button
            color="primary"
            style="margin-left: 50px; margin-top: 20px"
            (click)="add1()"
          >
            {{ isLoading1 ? "Adding..." : "Add" }}
          </button>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
</div>
